import {
  useAuthorisedEntities,
  useSelectedLp,
} from '@amzn/carrierlogistics-commons/dist/hooks/authorisation';
import { isEmpty } from 'lodash';
import useTermReportsConfig from './useTermReportsConfig';
import { REPORTS_SHARING_PATH_PREFIX } from '../constants/routes';
import {
  AUTHORIZATION,
  AUTHORIZED_LP_FOR_SP_PERFORMANCE,
  AUTHORIZED_LP_FOR_SP_PERFORMANCE_BETA,
} from '../constants/authorization';
import isSiteExternal from '../utils/isSiteExternal';
import { useAuthorizedLogisticParties } from '@amzn/LogisticPartyHelperLib/dist';
import { SP_PERFORMANCE_MANAGEMENT } from '../constants';
import { CARRIER_LOGISTICS_URL_PREFIXES } from '../config/env/endpointConfig';

const getSideMenuNavItems = (termReportConfigList) => {
  return termReportConfigList.map((termReportConfig) => {
    // In case of report sharing, if user is not authorized for term
    // Below isAuthorized true for children report types is to handle the case when user has access to the term
    // Else if term's isAuthorized is false then all children is automatically disabled by UI component
    const children = termReportConfig?.reportConfigList.map((reportConfig) => ({
      link: `${REPORTS_SHARING_PATH_PREFIX}/${termReportConfig.termUrlPath}/${reportConfig.reportTypeUrlPath}`,
      label: reportConfig.reportTypeDisplayName,
      children: false,
      isAuthorized: true,
      isExternalAllowed: reportConfig?.isExternalAllowed ?? true,
    }));

    return {
      label: termReportConfig.termDisplayName,
      link: `${REPORTS_SHARING_PATH_PREFIX}/${termReportConfig.termUrlPath}`,
      pamPermKey: termReportConfig.term,
      children: true,
      childNodes: children,
      hide: false,
    };
  });
};

export const useSideNavMenuItems = () => {
  const { termReportConfigs } = useTermReportsConfig();
  const sideMenuNavItems = getSideMenuNavItems(termReportConfigs);
  if (isSiteExternal()) {
    const authorizedEntities = useAuthorisedEntities();
    const lpSelected = useSelectedLp();

    const entitiesWithPermissions = sideMenuNavItems.map(({ ...config }) => {
      if (isEmpty(lpSelected)) return { isAuthorized: false, ...config };
      const url = window.location.href;
      const authorisedLPForSPPerformance = url.includes(
        CARRIER_LOGISTICS_URL_PREFIXES.BETA_URL_PREFIX
      )
        ? AUTHORIZED_LP_FOR_SP_PERFORMANCE_BETA
        : AUTHORIZED_LP_FOR_SP_PERFORMANCE;

      // temp change for beta testing wil be replaced by AUTHORIZED_LP_FOR_SP_PERFORMANCE
      if (
        config.pamPermKey === SP_PERFORMANCE_MANAGEMENT &&
        lpSelected.lpId !== authorisedLPForSPPerformance
      )
        return { isAuthorized: false, ...config };

      const isAuthorized =
        authorizedEntities?.[config.pamPermKey]?.length &&
        authorizedEntities?.[lpSelected.lpId]?.includes(AUTHORIZATION.ACCESS);

      // Filter out report types which are not allowed for external flow
      return {
        isAuthorized,
        ...config,
        childNodes: config?.childNodes?.filter(
          (cNode) => cNode.isExternalAllowed
        ),
      };
    });

    return { sideMenuNavItems: entitiesWithPermissions };
  }

  //TODO: temp change will be deprecated once we are able to give permission based on report type
  const { authorizedLps } = useAuthorizedLogisticParties(
    SP_PERFORMANCE_MANAGEMENT,
    true
  );
  const desiredLP = authorizedLps?.find(
    (lp) => lp.logisticsPartyId === AUTHORIZED_LP_FOR_SP_PERFORMANCE
  );
  const filteredSideNavItems = sideMenuNavItems?.filter(
    (sideNavItem) => sideNavItem.pamPermKey !== SP_PERFORMANCE_MANAGEMENT
  ) || [{}];

  if (!isEmpty(authorizedLps) && !desiredLP && !isEmpty(filteredSideNavItems)) {
    return { sideMenuNavItems: filteredSideNavItems };
  }

  return { sideMenuNavItems };
};

export default useSideNavMenuItems;
